import React from 'react';

const ChatBotIcon = React.memo(() => {
  return (
    <svg width="48px" height="48px" viewBox="0 0 56 56" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <clipPath id="roundedClip">
          <rect x="0" y="0" width="56" height="56" rx="28" ry="28" />
        </clipPath>
      </defs>

      <rect
        x="0.5"
        y="0.5"
        width="55"
        height="55"
        rx="27.5"
        ry="27.5"
        fill="#e6f4ff"
        stroke="#85a5ff"
        strokeWidth="1"
      />

      <image
        href="/img/star-06.svg"
        x="8"
        y="6"
        width="40"
        height="44"
        clipPath="url(#roundedClip)"
        preserveAspectRatio="xMidYMid meet"
      />
    </svg>
  );
});

export default ChatBotIcon;
